import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { authenticate, getLastConnectedUser } from '../../redux/modules/auth';
import { useNavigate } from 'react-router-dom';
import {
    Form,
    FormGroup,
    Input,
    Button
} from 'reactstrap';

import logo  from '../../assets/images/logo.png';
import back1 from '../../assets/images/back_login1.jpg';
import back2 from '../../assets/images/back_login2.jpg';
import back3 from '../../assets/images/back_login3.jpg';

import './Login.scss';

// Random background
const rand = parseInt(Math.random() * 1000, 10);
const back = rand % 3 === 1 ? back1 : (rand % 3 === 2 ? back2 : back3);

const Login = () => {
    const { user } = useSelector(state => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLastConnectedUser());
    }, []);

    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');

    const { t }    = useTranslation();
    const handleSubmit = e => {
        e.preventDefault();
        dispatch(authenticate(email, password));
    }

    const {
        logInErrorMessage,
        isAuthenticating,
        logInError,
    } = useSelector(state => state.auth)

    if (user?.id)
        return navigate('/');

    return (
        <div className="Login text-center">
            <div className="wrapper">
                <div className="background" style={{ backgroundImage: "url(" + back + ")"}} ></div>
                <Form onSubmit={handleSubmit} className="form-signin">
                    <img className="logo" src={logo} alt="logo" />
                    <br/>
                    <FormGroup>
                        <Input required type="email" autoComplete="username email" name="email" id="email" placeholder={t("login.email")} value={ email } onChange={ e => setEmail(e.target.value) } />
                    </FormGroup>
                    <FormGroup>
                        <Input required type="password" autoComplete="current-password" name="password" id="password" placeholder={t("login.password")} value={ password } onChange={ e => setPassword(e.target.value) }/>
                    </FormGroup>

                    <Button className="btn btn-lg btn-block btn-dark">
                        {isAuthenticating ?
                            <span>
                                &nbsp;<i className="fa fa-spinner fa-spin"></i>
                            </span>
                            :
                            <span>{t('app.login')}</span>
                        }
                    </Button>

                    {logInError &&
                        <div>
                            <br/>
                            <div className="alert alert-danger">
                                <i className="fa fa-warning"></i>&nbsp;
                                {logInErrorMessage}
                            </div>
                        </div>
                    }
                </Form>
            </div>
        </div>
    );
}

export default Login;
